import 'vazirmatn/Vazirmatn-font-face.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './features/irancharsouq-admin/irancharsouq-admin.css';

import Navigation from '@/components/layout/Navigation';
import BackToTop from '@/components/layout/BackToTop';
import AppRoutes from '@/routes/AppRoutes';
import { MarketplaceProvider } from '@/features/marketplace/context/marketplaceContext';

export default function App() {

  return (
      <MarketplaceProvider>
       <div className="app-wrapper">
         <Navigation />
         <main>
           <AppRoutes />
         </main>
         <BackToTop />
       </div>
      </MarketplaceProvider>
  );
}